import React, { useEffect } from 'react';

const RowDetailsSheet = ({ title, fields, actions, onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, []);

  return (
    <>
      <div className="rds-overlay" onClick={onClose} />
      <div className="rds-sheet" role="dialog" aria-modal="true">
        <div className="rds-handle" />
        <div className="rds-header">
          <span className="rds-title">{title || 'Details'}</span>
          <button type="button" className="rds-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="rds-fields">
          {fields.map(({ label, value, wide }) => (
            <div key={label} className={wide ? 'rds-field rds-field-wide' : 'rds-field'}>
              <div className="rds-field-label">{label}</div>
              <div className="rds-field-value">{value != null && value !== '' ? value : '—'}</div>
            </div>
          ))}
        </div>
        {actions && actions.length > 0 && (
          <div className="rds-actions">
            {actions}
          </div>
        )}
      </div>
    </>
  );
};

export default RowDetailsSheet;
